import { IEntityListDynamicCellComponent, IEntityListComponentMembers } from '@mt-ng2/entity-list-module';
import { Component } from '@angular/core';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { ICarrier } from '../../../model/interfaces/carrier';
import { finalize } from 'rxjs/operators';
import { CarrierService } from '../../services/carrier.service';

@Component({
    styles: [`

    `],
    templateUrl: './archive-carrier-list.component.html',
    standalone: false
})
export class ArchiveCarrierListComponent implements IEntityListDynamicCellComponent {
    entityListComponentMembers: IEntityListComponentMembers;
    item: ICarrier;
    isLoading = false;

    constructor(private carrierService: CarrierService,
        private notificationsService: NotificationsService
    ) { }

    set entity(value: ICarrier) {
        this.item = value;
    }

    toggleArchive(event: MouseEvent): void {
        this.item.Archived = !this.item.Archived;
        event.stopPropagation();
        if (!this.isLoading) {
            this.isLoading = true;
            const partialObject = { Id: this.item.Id, Archived: this.item.Archived };
            this.carrierService
                .updatePartial(partialObject, this.item.Id)
                .pipe(finalize(() => (this.isLoading = false)))
                .subscribe({
                    next: () => {
                        const archiveText = this.item.Archived ? 'archived' : 'unarchived';
                        this.notificationsService.success(`Successfully ${archiveText} carrier ${this.item.Name}`);
                        this.entityListComponentMembers.getEntities();
                    },
                    error: () => this.notificationsService.error('Archive failed')
                });
        }
    }
}
